const IFRAME_MESSAGE_SERVICE_MESSAGE_ID = 'OSWALD_IFRAME_MESSAGE_ID';
const IFRAME_SERVICE_RESET_IDLE_MESSAGE_ID = 'OSWALD_IFRAME_RESET_IDLE_MESSAGE';
function createIFrameMessageService() {
    const subscriptions = new Map();
    window.addEventListener('message', (event) => {
        const id = event.data[IFRAME_MESSAGE_SERVICE_MESSAGE_ID];
        const listeners = subscriptions.get(id) || new Set();
        for (const listener of listeners) {
            listener(event.data);
        }
    }, false);
    const publish = (window, message) => {
        window.postMessage(message, '*');
    };
    const publishToIFrame = (id, target, message) => {
        const iframeElement = document.querySelector(`#${target}`);
        if (!iframeElement || !iframeElement.contentWindow) {
            throw new Error(`[IFrame Message Service]: IFrame ${target} not found.`);
        }
        const messageWithId = {
            ...message,
            [IFRAME_MESSAGE_SERVICE_MESSAGE_ID]: id,
        };
        publish(iframeElement.contentWindow, messageWithId);
    };
    const publishToParent = (id, message) => {
        if (!window.parent || (window.parent && window.parent === window)) {
            throw new Error('[IFrame Message Service]: No parent found in the current window.');
        }
        const messageWithId = {
            ...message,
            [IFRAME_MESSAGE_SERVICE_MESSAGE_ID]: id,
        };
        publish(window.parent, messageWithId);
    };
    const subscribe = (id, fn) => {
        const listeners = subscriptions.get(id) ?? new Set();
        if (listeners.has(fn)) {
            throw new Error('[IFrame Message Service]: This listener is already listening to messages.');
        }
        listeners.add(fn);
        subscriptions.set(id, listeners);
        return () => {
            const listeners = subscriptions.get(id) ?? new Set();
            listeners.delete(fn);
            subscriptions.set(id, listeners);
        };
    };
    return {
        publishToIFrame,
        publishToParent,
        subscribe,
    };
}
const IFrameMessageService = createIFrameMessageService();
export { IFRAME_MESSAGE_SERVICE_MESSAGE_ID, IFRAME_SERVICE_RESET_IDLE_MESSAGE_ID, IFrameMessageService, };
//# sourceMappingURL=iframe-message-service.js.map